export const NUDGE_MINIMIZE_DEFAULTS = {
    enableMinimize: {
        propertyName: "Enable Minimize",
        propertyType: "select",
        propertyValue: "no",
        propertyOptions: [
            { optionName: "Yes", optionValue: "yes" },
            { optionName: "No", optionValue: "no" },
        ],
    },
    minimizePosition: {
        propertyName: "Minimize Position",
        propertyType: "select",
        propertyValue: "bottom-right",
        propertyOptions: [
            { optionName: "Bottom Left", optionValue: "bottom-left" },
            { optionName: "Bottom Center", optionValue: "bottom-center" },
            { optionName: "Bottom Right", optionValue: "bottom-right" },
        ],
    },
    minimizedLabel: {
        propertyName: "Minimized Label",
        propertyType: "text",
        propertyMaxLength: "30",
        propertyValue: "Offer",
    },
    pillBackgroundColor: {
        propertyName: "Pill Background Color",
        propertyType: "color",
        propertyValue: "#7c3aed",
    },
    pillBorderColor: {
        propertyName: "Pill Border Color",
        propertyType: "color",
        propertyValue: "#a78bfa",
    },
    pillBorderWidth: {
        propertyName: "Pill Border Width",
        propertyType: "number",
        propertyValue: 2,
    },
    pillAnimation: {
        propertyName: "Pill Animation",
        propertyType: "select",
        propertyValue: "pulse",
        propertyOptions: [
            { optionName: "Pulse", optionValue: "pulse" },
            { optionName: "Bounce", optionValue: "bounce" },
            { optionName: "Glow", optionValue: "glow" },
            { optionName: "Slide", optionValue: "slide" },
            { optionName: "None", optionValue: "none" },
        ],
    },
};
